import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrandProvider } from './providers/BrandProvider';
import { ThemeProvider } from './providers/ThemeProvider';
import App from './App';
import AutoTooltip from './components/ui/AutoTooltip';
import DatePickerLayer from './components/ui/DatePickerLayer';
import SelectLayer from './components/ui/SelectLayer';
import './i18n';
import './styles/index.css';
import { applyLiveQueryDefaults } from './utils/livePolling';
import { initCapture } from './modules/bug-report/capture';
import { watchAuthAcrossTabs } from './utils/authTabSync';
import { useAuthStore } from './store/authStore';
import AuthSwitchedOverlay from './components/AuthSwitchedOverlay';

initCapture();
// D-279 (QX-ב, QA-D279): ANOTHER user signing in in another tab blocks this one until it is
// refreshed (never a page of one user sending with another's token).
watchAuthAcrossTabs(window, () => useAuthStore.getState().user?.id);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});
// P-60 (D-236): central live-update policy (replaces per-page timers; see utils/livePolling.ts).
applyLiveQueryDefaults(queryClient);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrandProvider>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <App />
          <AutoTooltip />
          <DatePickerLayer />
          <SelectLayer />
          <AuthSwitchedOverlay />
        </QueryClientProvider>
      </ThemeProvider>
    </BrandProvider>
  </React.StrictMode>
);